import React from 'react';
import { Header, Aside } from '../';
import styles from './Top.module.sass';

export const Top = () => {
  return (
    <div className={styles.Top}>
      <div className={`${styles.ContentTop} u-wrapper`}>
        <Header />
        <Aside />
      </div>
    </div>
  );
};
